<template>
  <div class="sm:px-10 md:px-32 lg:px-64 my-10 bg-gray-500 py-10">
    <BackButton @back="back('submit-request')"/>
    <v-card>
      <v-card-title>
        <div v-html="title" />
      </v-card-title>
      <v-card-text>
        <div v-for="(item, i) in menus" :key="i">
          <!-- <v-btn class="py-2 my-1" @click="onPress(item.name)">
           
          </v-btn> -->
          <NormalButton :label="item.label" @onPress="onPress(item.name)"/>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import NormalButton from "../../common/NormalButton.vue";
import BackButton from "@/common/BackButton";
export default {
  data() {
    return {
      title: "Transfer / change property",
      subTitle: "Select one",
      menus: [
        {
          label:
            "Transfer to a different property / Change house model (same contract price)",
          name: "transfer-property-form",
        },
        {
          label:
            "Upgrade from lot to house and lot / Upgrade unit type (higher contract price)",
          name: "upgrade-property-form",
        },
      ],
    };
  },
  components: { NormalButton, BackButton },
  methods: {
    onPress(name) {
      this.$router.push({ name: name });
    },
    back(n){
      this.$router.push({name:n})
    }
  },
};
</script>